export default "__VITE_ASSET__c1d8f2b9__"